import { connect } from "../../store/connect";
import { DeepLinkScreen } from "./deep-link-screen";

export const DeepLinkContainer = connect(
  (state) => ({}),
  (dispatch) => ({})
)(DeepLinkScreen);
